import {
  CHANGE_DADOS_INICIAIAS_PJ_VALUE_FORM,

  LOADING_DADOS_INICIAIAS_PJ_CNPJ,
  SET_DADOS_INICIAIAS_PJ_CNPJ,
  ERROR_DADOS_INICIAIAS_PJ_CNPJ,

  LOADING_DADOS_INICIAIAS_PJ_CODIGO_GERENTE,
  SET_DADOS_INICIAIAS_PJ_CODIGO_GERENTE,
  ERROR_DADOS_INICIAIAS_PJ_CODIGO_GERENTE,

  LOADING_DADOS_INICIAIAS_PJ_NOME_GERENTE,
  ERROR_DADOS_INICIAIAS_PJ_NOME_GERENTE,

  SET_DADOS_INICIAIAS_PJ_CNAE,
  LOADING_DADOS_INICIAIAS_PJ_CNAE,
  ERROR_DADOS_INICIAIAS_PJ_CNAE,
  HANDLER_CHANGE_DADOS_INICIAIS_PJ_CNAE,

  SET_CODIGO_GERENTE_VIA_LINK_PJ,
  SET_ID_DDIPAIS_DADOS_INICIAIS_PJ

} from './types';

const initialState = {
  formPJ: {
    dadosIniciais_codigoGerente: '',
    dadosIniciais_nomeGerente: '',
    dadosIniciais_razaoSocial: '',
    dadosIniciais_cnpj: '',
    dadosIniciais_cnae: null,
    dadosIniciais_nomeContato: '',
    dadosIniciais_emailContato: '',
    dadosIniciais_telefoneContato: '',
    dadosIniciais_ddiTelefoneContato: '55',
    dadosIniciais_cpfContato: ''
  },
  dadosIniciais_CnpjExiste: null,
  loadingDadosIniciaisCnpj: false,
  errorBoolDadosIniciaisCnpj: null,
  dropdownCNAEList: [],
  dadosIniciais_codigoGerenteViaLink: false,
  dadosIniciais_idDDDpais: null,
  errorCodigoGerente: ""
}


export default function dadosIniciaisPJReducer(state = initialState, action) {
  switch (action.type) {
    
    case SET_ID_DDIPAIS_DADOS_INICIAIS_PJ:
      return {...state, dadosIniciais_idDDDpais: action.payload}
    case LOADING_DADOS_INICIAIAS_PJ_CODIGO_GERENTE:
      return { ...state, loadingDadosGerente: action.payload }

    case SET_DADOS_INICIAIAS_PJ_CODIGO_GERENTE:
      return { ...state, formPJ: { ...state.formPJ, dadosIniciais_codigoGerente: action.payload } }

    case ERROR_DADOS_INICIAIAS_PJ_CODIGO_GERENTE:
      return { ...state, errorCodigoGerente: action.payload }

    case LOADING_DADOS_INICIAIAS_PJ_NOME_GERENTE:
      return { ...state, loadingDadosGerente: action.payload }

    case ERROR_DADOS_INICIAIAS_PJ_NOME_GERENTE:
      return { ...state, errorNomeGerente: action.payload }

    case CHANGE_DADOS_INICIAIAS_PJ_VALUE_FORM:
      return { ...state, formPJ: action.payload }

    case SET_DADOS_INICIAIAS_PJ_CNPJ:
      return { ...state, dadosIniciais_CnpjExiste: action.payload }

    case LOADING_DADOS_INICIAIAS_PJ_CNPJ:
      return { ...state, loadingDadosIniciaisCnpj: action.payload }

    case ERROR_DADOS_INICIAIAS_PJ_CNPJ:
      return { ...state, errorBoolDadosIniciaisCnpj: action.payload }

    case SET_DADOS_INICIAIAS_PJ_CNAE:
      return { ...state, dropdownCNAEList: action.payload }

    case LOADING_DADOS_INICIAIAS_PJ_CNAE:
      return { ...state, loadingDadosCNAE: action.payload }

    case ERROR_DADOS_INICIAIAS_PJ_CNAE:
      return  { ...state, errorListDadosCNAE: action.payload }

    case HANDLER_CHANGE_DADOS_INICIAIS_PJ_CNAE:
      return  { ...state, formPJ: { ...state.formPJ, dadosIniciais_cnae: action.payload} }

    case SET_CODIGO_GERENTE_VIA_LINK_PJ:
      return { ...state, dadosIniciais_codigoGerenteViaLink: action.payload }

    default:
      return state
  }
}